// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticket-input {
  position: relative;
  background-color: var(--ion-background-color);
  color: var(--color-font-base);
  padding: calc(var(--spacing) / 2);
  margin-bottom: calc(var(--spacing) / 2);
  border-radius: var(--spacing-quarter);
  border: solid var(--ion-background-secondary-color);
  border-width: 1px 1px 1px 30px;
}
.ticket-input.--hasError {
  border-color: var(--ion-color-danger);
}
.ticket-input__actions {
  position: absolute;
  z-index: 2;
  right: 2px;
  top: 0px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.ticket-input__information {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-half);
  margin-right: calc(var(--spacing) * 1.5);
}
.ticket-input__information .ticket-id {
  line-height: 28px;
  white-space: nowrap;
}
.ticket-input__information .ticket-holder {
  font-size: 16px;
  line-height: 28px;
  font-weight: bold;
}
.ticket-input__information p.ticket {
  font-weight: bold;
  text-transform: uppercase;
  line-height: 1.2;
}
.ticket-input__information p.ticket .type {
  font-weight: normal;
  text-transform: none;
}
.ticket-input__information p {
  margin: 0;
  opacity: 0.75;
  font-size: 16px;
  color: var(--color-font-base);
}
.ticket-input__form {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s ease-out;
}
.ticket-input__form .form {
  margin-top: var(--spacing-half);
}
.ticket-input__form .form__fields {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.ticket-input__form .form__fields .actions {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: var(--spacing);
  gap: var(--spacing);
}
.ticket-input__form .form__fields .actions button {
  margin-left: calc(var(--spacing) / 2);
}
.ticket-input__form .full-width {
  width: 100%;
}
.ticket-input.--disabled {
  opacity: 0.5;
  pointer-events: none;
}
.ticket-input.--showForm .ticket-input__form {
  max-height: 800px;
}
.ticket-input.--hideForm .ticket-input__form {
  max-height: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/general-components/ticket-input/ticket-input.component.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,6CAAA;EACA,6BAAA;EACA,iCAAA;EACA,uCAAA;EACA,qCAAA;EACA,mDAAA;EACA,8BAAA;AAAJ;AAEI;EACI,qCAAA;AAAR;AAII;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;AAFR;AAKI;EACI,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,wCAAA;AAHR;AAMQ;EACI,iBAAA;EACA,mBAAA;AAJZ;AAOQ;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;AALZ;AAQQ;EACI,iBAAA;EACA,yBAAA;EACA,gBAAA;AANZ;AAQY;EACI,mBAAA;EACA,oBAAA;AANhB;AAUQ;EACI,SAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;AARZ;AAYI;EACI,gBAAA;EACA,aAAA;EACA,oCAAA;AAVR;AAYQ;EACI,+BAAA;AAVZ;AAYY;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;AAVhB;AAYgB;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,2BAAA;EACA,mBAAA;AAVpB;AAYoB;EACI,qCAAA;AAVxB;AAgBQ;EACI,WAAA;AAdZ;AAkBI;EACI,YAAA;EACA,oBAAA;AAhBR;AAoBQ;EACI,iBAAA;AAlBZ;AAsBQ;EACI,aAAA;AApBZ","sourcesContent":["\n.ticket-input {\n    position: relative;\n    background-color: var(--ion-background-color);\n    color: var(--color-font-base);\n    padding: calc(var(--spacing) / 2);\n    margin-bottom: calc(var(--spacing) / 2 );\n    border-radius: var(--spacing-quarter);\n    border: solid var(--ion-background-secondary-color);\n    border-width: 1px 1px 1px 30px;\n\n    &.--hasError {\n        border-color: var(--ion-color-danger);\n    }\n\n\n    &__actions {\n        position: absolute;\n        z-index: 2;\n        right: 2px;\n        top: 0px;\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-end;\n    }\n\n    &__information {\n        display: flex;\n        flex-direction: column;\n        gap: var(--spacing-half);\n        margin-right: calc(var(--spacing) * 1.5);\n\n\n        .ticket-id {\n            line-height: 28px;\n            white-space: nowrap;\n        }\n\n        .ticket-holder {\n            font-size: 16px;\n            line-height: 28px;\n            font-weight: bold;\n        }\n\n        p.ticket {\n            font-weight: bold;\n            text-transform: uppercase;\n            line-height: 1.2;\n\n            .type {\n                font-weight: normal;\n                text-transform: none;\n            }\n        }\n\n        p {\n            margin: 0;\n            opacity: 0.75;\n            font-size: 16px;\n            color: var(--color-font-base);\n        }\n    }\n\n    &__form {\n        overflow: hidden;\n        max-height: 0;\n        transition: max-height 0.5s ease-out;\n\n        .form {\n            margin-top: var(--spacing-half);\n\n            &__fields {\n                display: flex;\n                flex-direction: column;\n                align-items: flex-end;\n                \n                .actions {\n                    width: 100%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: flex-end;\n                    padding-top: var(--spacing);\n                    gap: var(--spacing);\n\n                    button {\n                        margin-left: calc(var(--spacing) / 2);\n                    }\n                }\n            }\n        }\n\n        .full-width {\n            width: 100%;\n        }\n    }\n\n    &.--disabled {\n        opacity: 0.5;\n        pointer-events: none;\n    }\n\n    &.--showForm{\n        .ticket-input__form {\n            max-height: 800px;\n        }\n    }\n    &.--hideForm{\n        .ticket-input__form {\n            max-height: 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
